
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal-blogs",
      function () {
        return require("private-next-pages/legal-blogs/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal-blogs"])
      });
    }
  